<ng-container *ifScreenSize="screenType.Mobile">
  <fgb-mobile-nav-menu></fgb-mobile-nav-menu>
  <ng-container *inPopulation="[population.Kids]">
    <div class="container py-3 bg-primary">
      <img class="kids-banner-img rounded" [src]="'images/kids-home-banner-mobile.jpg' | contentAssetImage" />
    </div>
  </ng-container>
  <ng-container *notInPopulation="[population.Kids]">
    <div class="container py-3 bg-primary">
      <img class="kids-banner-img rounded" [src]="'banners/haws-rewards-banner.jpg' | contentAssetImage" />
    </div>
  </ng-container>
  <fgb-home-nav></fgb-home-nav>
</ng-container>

<ng-container *ifScreenSize="screenType.Desktop">
  <ng-container *inPopulation="[population.Kids]">
    <div class="kids-banner">
      <img class="" [src]="'banners/kids-banner.jpg' | contentAssetImage" />
    </div>
  </ng-container>
  <ng-container *notInPopulation="[population.Kids]">
    <div class="bg-primary banner-img-container">
      <img class="w-100" [src]="'banners/rewards-banner-desktop.png' | contentAssetImage" />
    </div>
  </ng-container>
  <div class="container">
    <div class="row pt-4">
      <div class="col-lg-6">
        <fgb-member-card [showLogo]="true"></fgb-member-card>
      </div>
      <div class="col-lg-6">
        <div
          *notInPopulation="[population.Kids]"
          [routerLink]="'/guardians'"
          class="card add-hawks-card bg-primary text-center d-flex align-items-center justify-content-center cursor-pointer"
          [style.background]="'url(' + ('images/kidsimage2026.png' | contentAssetImage) + ') lightgray 50% / cover no-repeat'"
        ></div>

        <div
          *inPopulation="[population.Kids]"
          [routerLink]="'/games'"
          class="card kid-add-hawks-card bg-primary text-center d-flex align-items-center justify-content-center cursor-pointer"
          [style.background]="'url(' + ('images/kid-hawk-widget.jpg' | contentAssetImage) + ') lightgray 50% / cover no-repeat'"
        ></div>
      </div>
    </div>
  </div>
</ng-container>

<!--Vouchers-->
<div class="container home-page">
  <fgb-vouchers></fgb-vouchers>

  <!-- Featured Marketplace -->
  <ng-container *notInPopulation="[population.Kids]">
    <ng-container *ngIf="rewardMarketplaceItems$ | async as marketplaceItems">
      <ng-container *ngIf="marketplaceItems.length">
        <div class="d-flex justify-content-between pt-3">
          <h2 class="heading-title mt-0 mb-0 text-white">
            {{ 'featured.marketplace' | translate: { fgbdefault: 'Experiences  & Rewards' } }}
          </h2>
          <span class="d-flex align-items-center">
            <a class="home-link" [routerLink]="['/rewards/marketplace']">
              <span class="material-icons text-white">keyboard_arrow_right</span>
            </a>
          </span>
        </div>
        <owl-carousel-o [options]="customOptions">
          <ng-container *ngFor="let marketplaceItem of marketplaceItems">
            <ng-template carouselSlide [width]="marketplaceItems.length <= 2 ? rewardsWidth : 0">
              <fgbcl-marketplace-list-item
                [marketplaceItem]="marketplaceItem"
                [marketplaceItemTypes]="[0, 1, 2]"
              ></fgbcl-marketplace-list-item>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<!--Scorecard carousel-->
<div class="mt-4">
  <fgbcl-scorecard-carousel [link]="'challenges'" [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>
</div>

<!--Kids Rewards-->
<ng-container *inPopulation="[population.Kids]">
  <div class="container">
    <fgbcl-featured-rewards showAllPath="/rewards/marketplace"></fgbcl-featured-rewards>
  </div>
</ng-container>

<!-- Offers -->
<ng-container *notInPopulation="[population.Kids]">
  <fgbcl-campaigns-offers-list
    [showAllOffers]="true"
    (dataChange)="onCampaignOfferListChange($event)"
  ></fgbcl-campaigns-offers-list>
</ng-container>

<div class="container">
  <!-- Featured Events -->
  <ng-container *notInPopulation="[population.Kids]">
    <ng-container *ngIf="marketplaceItems$ | async as marketplaceItems">
      <ng-container *ngIf="marketplaceItems.length">
        <div class="d-flex justify-content-between pt-3">
          <h2 class="heading-title mt-0 mb-0 text-white">{{ 'featured.events' | translate: { fgbdefault: ' Events' } }}</h2>
          <span class="d-flex align-items-center">
            <a class="home-link" [routerLink]="['/rewards/events']">
              <span class="material-icons text-white">keyboard_arrow_right</span>
            </a>
          </span>
        </div>
        <owl-carousel-o [options]="customOptions">
          <ng-container *ngFor="let marketplaceItem of marketplaceItems">
            <ng-template carouselSlide [width]="marketplaceItems.length <= 2 ? rewardsWidth : 0">
              <fgbcl-marketplace-list-item
                [marketplaceItem]="marketplaceItem"
                [marketplaceItemTypes]="[3]"
              ></fgbcl-marketplace-list-item>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- Announcements -->
  <fgbcl-announcements></fgbcl-announcements>
</div>
